import styled from 'styled-components'
import { ReactNode } from 'react'

const CardWrapper = styled.div`
  /* width: 320px; */
`

const Card = styled.div`
  width: 100%;
  height: 200px;
  background: ${({ theme }) => theme.colors.Cardwhite};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  box-sizing: border-box;
  /* margin-bottom: 2rem; */
  margin: 0 0 2rem 0;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  h1 {
    margin: 0;
  }
`

interface CardProps {
  children: ReactNode
}

const CardContainer = ({ children }: CardProps) => {
  return (
    <CardWrapper>
      <Card>{children}</Card>
    </CardWrapper>
  )
}
const HomePageCard = styled(Card)`
  width: -webkit-fill-availabl;
  height: 120px;
  display: flex;
  justify-content: center;
  margin: 0;
  align-items: center;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  /* flex-direction: column; */
  background: ${({ theme }) => theme.colors.Cardwhite};

  /* & */
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: -webkit-fill-available;
    padding: 0px;
    /* width: 315px;
    height: 199px; */
  }
`
const InvestmentListCard = styled(Card)`
  width: 544px;
  height: 371px;
  display: flex;
  padding: 0px;
  justify-content: space-between;
  align-items: flex-start;
  @media (min-width: ${({ theme }) =>
      theme.responsive.ipad}) and (max-width: 1080px) {
    width: 400px;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 90%;
    height: 210px;
  }
  @media (min-width: 300px) and (max-width: 400px) {
    width: 95%;
  }
`
const SettingsCard = styled(Card)`
  width: 346px;
  height: 78px;
  display: flex;
  padding: 24px 27px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #cdd2fd;
  border-radius: 10px;
  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    width: 450px;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    height: 60px;
    width: 80vw;
    /* margin-left: 3rem; */
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    height: 60px;
    width: 80vw;
    margin-left: 0rem;
  }
`

const PrivacyPolicyCard = styled.div`
  width: 346px;
  height: 78px;
  display: flex;
  padding: 24px 27px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #cdd2fd;
  border-radius: 10px;
  @media (max-width: 900px) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    height: 60px;
    width: 350px;
  }
`

const CollaboCard = styled(Card)`
  width: 352px;
  height: 220px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.CollaboBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 434px) {
    width: 90%;
  }
`
const CollaboInfoCard = styled(Card)`
  width: 680px;
  height: 220px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0px 41px 0px 39px;
  margin-left: 88px;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    margin-left: 0px;
  }
  @media (min-width: ${({ theme }) =>
      theme.responsive.ipad}) and (max-width: ${({ theme }) =>
      theme.responsive.laptop}) {
    margin-left: 20px;
  }
`
const MyCollaboInfoCard = styled(Card)`
  width: 97%;
  height: 320px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.Cardwhite};
  background: ${({ theme }) => theme.colors.Cardwhite};
  display: flex;
  align-items: flex-start;
  justify-content: start;
  padding: 0px 0px 0px 20px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    height: 200px;
  }
  @media (min-width: ${({ theme }) =>
      theme.responsive.mobile}) and (max-width: ${({ theme }) =>
      theme.responsive.ipad}) {
    height: 250px;
  }
`
const CollaboInviteCard = styled(Card)`
  width: 727px;
  height: 260px;
  border-radius: 13px;
  backdrop-filter: blur(33.2019px);
  border: 1px solid ${({ theme }) => theme.colors.Cardwhite};
  background: ${({ theme }) => theme.colors.Cardwhite};
  display: flex;
  align-items: flex-start;
  justify-content: start;
  padding: 10px 10px 0px 10px;
  margin-bottom: 50px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
  @media (min-width: ${({ theme }) =>
      theme.responsive.ipad}) and (max-width: 1100px) {
    width: 100%;
  }
  @media (min-width: ${({ theme }) =>
      theme.responsive.mobile}) and (max-width: ${({ theme }) =>
      theme.responsive.ipad}) {
    width: 90%;
  }
`
const InvestmentAmountCard = styled(Card)`
  width: 352px;
  height: 120px;
  border-radius: 10px;
  margin-top: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.Cardwhite};
  background: ${({ theme }) => theme.colors.secondPrimary};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: 200px;
  }
  @media (max-width: 390px) {
    width: 95%;
  }
  @media (max-width: 332px) {
    width: 97%;
  }
`
const InvestmentInterestCard = styled(Card)`
  width: 55%;
  height: 220px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.Cardwhite};
  background: ${({ theme }) => theme.colors.moneyInterestCard};
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 2rem 0; */
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 315px;
    height: 200px;
  }
  @media (min-width: 1110px) and (max-width: ${({ theme }) =>
      theme.responsive.laptop}) {
    width: 50%;
  }
  @media (min-width: ${({ theme }) =>
      theme.responsive.mobile}) and (max-width: 1110px) {
    width: 500px;
  }
`
const InvestmentCard = styled(Card)`
  background: #ffffff;
  border-radius: 10px;
  height: 370px;
  width: 310px;
  padding: 0;
  box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.09);
  position: relative;
  align-items: flex-start;
  /* text-align: left; */
`

const SavingsCard = styled(Card)`
  width: 320px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.secondPrimary};
  border-radius: 14px;
  color: white;
  @media (min-width: ${({ theme }) =>
      theme.responsive.ipad}) and (max-width: 1000px) {
    width: 90%;
  }

  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 100%;
    padding: 0 30px;
    height: 200px;
    margin-left: 0px;
  }
`

const SavingsLink = styled(Card)`
  width: 280px;
  height: 350px;
  justify-content: start;
  align-items: flex-start;
  padding: 20px;
  background: ${({ theme }) => theme.colors.Cardwhite};
  box-shadow: 0px 1.72308px 3.44615px rgba(0, 0, 0, 0.25);
  border-radius: 17.2308px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 272px;
    height: 220px;
  }
  @media (max-width: 350px) {
    width: 222px;
    height: 240px;
  }
`

const GeneralCard = styled(Card)``

export {
  CardContainer,
  HomePageCard,
  InvestmentListCard,
  SettingsCard,
  CollaboCard,
  CollaboInfoCard,
  MyCollaboInfoCard,
  CollaboInviteCard,
  InvestmentInterestCard,
  InvestmentAmountCard,
  InvestmentCard,
  SavingsCard,
  SavingsLink,
  GeneralCard,
  PrivacyPolicyCard,
}
